import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getCriticalCareSelector } from '../selectors'
import { CriticalCareConstants } from '../store/criticalCare.constants'
import { ICriticalCareState } from '../store/criticalCare.types'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { setAddToTimeLine } from '../store/criticalCare.actions'
import { addCriticalCareItem } from '../../../timeline/store/timeline.actions'

export function* saveCriticalCare() {
  let criticalCareState: ICriticalCareState = yield select(getCriticalCareSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  try {
    criticalCareState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: criticalCareState,
      actionField: (s) => s?.action?.name,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
      includeSnomedId: true,
    })
  } catch (error: unknown) {
    criticalCareState = handleNemsisCodeError(error, criticalCareState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.criticalCareStateList && pcrDoc.patient?.criticalCareStateList.length) {
    const index = pcrDoc.patient?.criticalCareStateList?.findIndex(
      (criticalCare) => criticalCare.key === criticalCareState.key
    )
    if (index !== -1) {
      pcrDoc.patient.criticalCareStateList[index] = criticalCareState
    } else {
      pcrDoc.patient?.criticalCareStateList.push(criticalCareState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, criticalCareStateList: [criticalCareState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addCriticalCareItem())
  } catch (e) {
    yield put(throwPcrException(`saveCriticalCare() error: ${e}`))
  }
}

export function* saveCriticalCareSaga() {
  yield takeLatest(
    [
      CriticalCareConstants.SET_DATE,
      CriticalCareConstants.SET_TIME,
      CriticalCareConstants.SET_DATE_TIME,
      CriticalCareConstants.SET_ASSESSED_BY,
      CriticalCareConstants.SET_ATTEMPTS,
      CriticalCareConstants.SET_RESPONSE,
      CriticalCareConstants.SET_PROCEDURE_COMPLICATIONS,
      CriticalCareConstants.SET_AUTHORIZATION,
      CriticalCareConstants.SET_ROLE_PERFORMING,
      CriticalCareConstants.SET_ROLE_PERFORMING_PNNV,
      CriticalCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      CriticalCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      CriticalCareConstants.SET_PTA,
      CriticalCareConstants.SET_SIZE,
      CriticalCareConstants.SAVE_CRITICAL_CARE,
    ],
    performWithMutexHOG,
    saveCriticalCare
  )
}
